import { jsx as _jsx } from "react/jsx-runtime";
// catmint/hooks/RouteDataContext — Context for passing server data to client components
import { createContext, } from "react";
export const RouteDataContext = createContext(undefined);
/**
 * Provider that makes server-fetched route data available to client components
 * via the useRouteData hook.
 */
export function RouteDataProvider({ children, data, }) {
    return (_jsx(RouteDataContext.Provider, { value: data, children: children }));
}
//# sourceMappingURL=RouteDataContext.js.map